"use client";
import Input from "@/components/common/Input";
import React from "react";
import { useContactForm } from "../hooks/useContactForm";

// const initialValues = {
//   full_name: "",
//   email: "",
//   phoneNo: "",
//   subject: "",
//   address: "",
//   message: "",
// };
// const formik = {
//   initialValues: initialValues,
//   handleSubmit: () => {},
//   values: {},
//   handleChange: () => {},
//   handleBlur: () => {},
//   errors: {},
//   touched: {},
// };
// const isLoading = false;

const SendUsMessage = () => {
  const { formik, isLoading } = useContactForm();
  return (
    <section>
      <div>
        <p className="typography-h5-semibold">Send Us a Message</p>
        <p className="typography-mid-body text-grey-800 my-4">
          Fill out the form below and we&apos;ll get back to you as soon as
          possible.
        </p>
      </div>

      <form onSubmit={formik.handleSubmit} className="flex flex-col gap-5">
        {/* full_name Name */}
        <Input
          id="fullname"
          name="fullname"
          label="Full Name"
          placeholder="Enter your full name"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <Input
          id="email"
          name="email"
          label="Email"
          placeholder="Enter your email"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <Input
          id="phone"
          name="phone"
          label="Phone"
          placeholder="Enter your phone"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <Input
          id="package"
          name="package"
          label="Subject"
          placeholder="Enter your subject"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <label
          htmlFor="message"
          className="typography-extra-large-body text-grey-500 w-full"
        >
          Message
        </label>
        <textarea
          className="w-full px-5 py-3 typography-extra-large-body font-light text-grey-400 rounded-lg border"
          id="message"
          name="message"
          placeholder="Tell us about the travel plans..."
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <button
          type="submit"
          disabled={isLoading}
          className={`flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white mt-3 py-3 px-5 rounded-3xl typography-large-body-regular text-center shadow-[0px_2px_4px_-2px_#0000001A,_0px_4px_6px_-1px_#0000001A] ${
            isLoading ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          Send Message
        </button>
      </form>
    </section>
  );
};

export default SendUsMessage;
